goog.provide('el8.ptdata.comments');

goog.require('el8.data.referencedUsers');
goog.require('el8.data.practiceUsers');
goog.require('el8.model.base');


el8.ptdata.comments = (function() {

    var _class = function(spec) {
        this.populate(spec);
    };
    _class.inheritsFrom(el8_Entity);

    _class.addStringProperty('message');
    _class.addDateTime('createDate');

    _class.addIntProperty('fromPracticeId');
    _class.addIntProperty('authorId');

    _class.addDateTime('readTime');
    _class.addIntProperty('readUserId');

    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);

        if (this.getAuthorId()) {
            var author = el8.data.referencedUsers.getById(this.getAuthorId());
            mapped['authorName'] = author ? author.getFullName() : '';
            mapped['authorStaffType'] = author ? author.getStaffType() : '';
        }

        mapped['readUserName'] = this.getReadUserId() ?
            el8.data.referencedUsers.getById(this.getReadUserId()).getFullName() : '';

        return mapped;
    };

    _class.prototype.isRead = function() {
        // a user has implicitly read any comment from their own practice
        var ownPracticeComment = (this.getFromPracticeId() === el8Globals.PRACTICE_ID);
        return ownPracticeComment || Boolean(this.getReadTime());
    };

    var that = new el8_EntitySet({
        model: function(spec) {
            return new _class(spec);
        }
    });

    return that;

})();
